module.exports = __webpack_public_path__ + "static/img/headBg_2.e2f5675d.png";